import { TabType } from 'owa-tab-store';
import { getStore as getTabStore } from 'owa-tab-store/lib/store/tabStore';
import {
    ComposeViewState,
    AsyncSendState,
    getStore as getComposeStore,
} from 'owa-mail-compose-store';

export default function findInlineComposeViewState(
    conversationId: string,
    includeDelayedSendState?: boolean
): ComposeViewState {
    const composeStore = getComposeStore();
    for (const tab of getTabStore().tabs) {
        if (tab.type == TabType.Compose && !tab.isShown) {
            const viewState = composeStore.viewStates.get(tab.data);

            if (
                viewState &&
                viewState.isInlineCompose &&
                viewState.conversationId == conversationId &&
                (viewState.asyncSendState == AsyncSendState.None ||
                    (includeDelayedSendState && viewState.asyncSendState == AsyncSendState.Delay))
            ) {
                return viewState;
            }
        }
    }

    return null;
}
